// import { User } from 'msal';
import { TYPES } from 'action-types/nickname';
import { ThunkDispatch } from 'redux-thunk';
import { Action } from 'redux';
import { generateErrors } from 'utilities/util';
import { callApiGet } from 'utilities/apiCaller';
export const setNickNameToken = (token:any) => {
    return async (dispatch: ThunkDispatch<any, any, Action>) => {
        dispatch({ type: TYPES.SET_NICKNAME, token });
        getNickName(token)
    }
}
export const getNickName = (token:any) => {
    return async (dispatch: ThunkDispatch<any, any, Action>) => {
        const userToken ={Authorization:`Bearer ${token}`}
        dispatch({ type: TYPES.GET_USER_NICKNAME.PENDING });
        try {
            const res = await callApiGet('https://graph.microsoft.com/v1.0/me?$select=employeeId,givenName,id,mailNickname', undefined,{ headers: {  ...userToken, 'Content-Type': 'application/x-www-form-urlencoded' } });
            dispatch({ type: TYPES.GET_USER_NICKNAME.FULFILLED, userNickName: res.data });
        } catch (e) {
            const errors = generateErrors(e);
            dispatch({ type: TYPES.GET_USER_NICKNAME.REJECTED, errors });
        }
    }
};